import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useStyles } from '../SchoolShow_style'
import Button from 'components/Button/Button'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'

const SchoolMoreInfoButton = (props) => {
    const { school } = props
    const classes = useStyles()

    return (
        <RouteMapLink target='_blank' redirectionUrl={school.url}>
            <Button size='small' className={classes.moreInfoButton}>
                <FormattedMessage id='school_page.faq.more_info_url'/>
            </Button>
        </RouteMapLink>
    )
}

export default SchoolMoreInfoButton
